import { ReduxState } from '../types/ReduxState';

export const initialState: ReduxState = {
  isShow: false,
  message: '',
  type: null,
};
